<template> 
  <div>
    <div  class="btn-group"  v-if="row.status == 2">
      <!--span class="span-icon-cerrado ml-4 pl-2 pr-2"><span class="icon icon-lock"> </span> Cerrado</span-->
      <img class="leftImg1 mr-3" src="@/assets/images/icons/cerrado.svg">
                               
    </div>
    <div  class="btn-group"  v-else>
      <img class="leftImg1 mr-3" src="@/assets/images/icons/pendiente.svg">
                     
      <!--span class="span-icon-pendiente ml-4 pl-2 pr-2"><span class="icon icon-circle-clock"> </span> Pendiente</span-->
       
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "EditFieldDelete",
  data() {
    return {
      selected: false
    }
  },
  props: ['row','field'],
  computed: {
    ...mapState("modTipshiftReport", ["tipshift","selectAll"]),
      ...mapGetters([
      'modTipshiftReport',
      ["getAllSelected"]
    ]),
  },
  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actSelectRow",
      "actEliminarRegistroNovedad"
    ]),
    
    eliminarRegistroNovedad(id){
      this.actEliminarRegistroNovedad(id);
    },

  },
};
</script>

<style lang="scss" scoped>
  .icon-lock {
      color: #779b49;
  }

  .icon-circle-clock {
    color: #e48d3d;
  }

  .span-icon-pendiente{
    /* Alert / Warning Bg */
    background: #FFF4EC;
    border-radius: 20px;
}

.span-icon-cerrado{
    /* Alert / Warning Bg */
    background: #EDF9F0;
    border-radius: 20px;
}

</style>